export enum StatusValidacaoImportacaoXmlNFeEntradaEnum {
  Pendente = 0,
  Sucesso = 1,
  Alerta = 2,
  Erro = 3,
}
